import { takeEvery, select, put } from 'redux-saga/effects';
import { fetchAppartments, updateAppartment } from '../api/appartments'
import { fetchVideos, updateVideo } from '../api/videos'
import { fetchTexts, updateText } from '../api/texts'
import { uploadImage } from '../api/vignette'

import _ from 'lodash'

function* changeVignette({ type, file, appartment, room, video, mode }) {
    const { cognito, app } = yield select()
    const { buckets } = app

    const response = yield uploadImage(cognito.creds, buckets.Images, file);

    yield put({ type: 'CHANGE_VIGNETTE_URL', url: response.Location, appartment, room, video, mode })
}

function* changeVignetteUrl({ type, appartment, room, video, mode, url }) {
    const { cognito, app } = yield select()
    const { tables } = app;

    if(mode === '360') {
        let appa = _.find(app.appartments, { Id: appartment })

        yield updateAppartment(cognito.creds, tables.Appartments, appa);
    }
    if(mode === 'videos') {
        let vid = _.find(app.videos, { Id: video })

        yield updateVideo(cognito.creds, tables.Videos, vid);
    }
}

function* retrieveTexts(action) {
    yield put({type:'RETRIEVE_TEXTS'})

    const { cognito, app } = yield select()
    const { tables } = app;
    const response = yield fetchTexts(cognito.creds, tables.Texts, action.language);

    yield put({type:'RETRIEVE_TEXTS_RESPONSE', response: response.Items})
}

function* saveText(action) {
    const { cognito, app } = yield select()
    const { tables } = app;

    let textEntity = _.find(app.texts, { Key: action.key })
    if(textEntity) {
        const response = yield updateText(cognito.creds, tables.Texts, textEntity);

        yield put({type:'SAVE_TEXT_RESPONSE', response: response.Item})
    }
    else {
        yield put({type:'SAVE_TEXT_FAIL'})
    }
}

function* saveAppartment(action) {
    const { cognito, app } = yield select()
    const { tables } = app;

    let appartEntity = _.find(app.appartments, { Id: action.appartmentId })
    if(appartEntity) {
        const response = yield updateAppartment(cognito.creds, tables.Appartments, appartEntity);

        yield put({type:'SAVE_APPARTMENT_RESPONSE', response: response.Item})
    }
    else {
        yield put({type:'SAVE_APPARTMENT_FAIL'})
    }
}

function* saveVideo(action) {
    const { cognito, app } = yield select()
    const { tables } = app;

    let videoEntity = _.find(app.videos, { Id: action.videoId })
    if(videoEntity) {
        const response = yield updateVideo(cognito.creds, tables.Videos, videoEntity);

        yield put({type:'SAVE_VIDEO_RESPONSE', response: response.Item})
    }
    else {
        yield put({type:'SAVE_VIDEO_FAIL'})
    }
}

function* retrieveAppartments(action) {
    yield put({type:'RETRIEVE_APPARTMENTS'})

    const { cognito, app } = yield select()
    const { tables } = app;

    const response = yield fetchAppartments(cognito.creds, tables.Appartments);

    yield put({type:'RETRIEVE_APPARTMENTS_RESPONSE', response: response.Items})
}

function* retrieveVideos(action) {
    yield put({type:'RETRIEVE_VIDEOS'})

    const { cognito, app } = yield select()
    const { tables } = app;

    const response = yield fetchVideos(cognito.creds, tables.Videos );

    yield put({type:'RETRIEVE_VIDEOS_RESPONSE', response: response.Items})
}

function* rootSaga(action) {
    yield takeEvery('XRETRIEVE_APPARTMENTS', retrieveAppartments)
    yield takeEvery('XRETRIEVE_VIDEOS', retrieveVideos)
    yield takeEvery('XRETRIEVE_TEXTS', retrieveTexts)
    yield takeEvery('SAVE_TEXT', saveText)
    yield takeEvery('SAVE_APPARTMENT', saveAppartment)
    yield takeEvery('SAVE_VIDEO', saveVideo)
    yield takeEvery('CHANGE_VIGNETTE', changeVignette)
    yield takeEvery('CHANGE_VIGNETTE_URL', changeVignetteUrl)
}

export default rootSaga;



// WEBPACK FOOTER //
// ./src/sagas/index.js